import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Card)`
  position: absolute;
  z-index: 3;
  height: auto !important;
  width: ${(p) => p.theme.spacing(50)};

  &:not(.isPopover) {
    margin-top: ${(p) => p.theme.spacing(6)};
  }
`;
